import { render } from "./FloatingButton.vue?vue&type=template&id=7cbb044e&scoped=true"
import script from "./FloatingButton.vue?vue&type=script&lang=js"
export * from "./FloatingButton.vue?vue&type=script&lang=js"

import "./FloatingButton.vue?vue&type=style&index=0&id=7cbb044e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbb044e"]])

export default __exports__